import { PropsWithChildren, ReactElement, useState, MouseEvent, useRef } from "react";
import { useEventListener } from "../../../hooks/UseEventListener";
import { className } from "../../../shared/helpers";
import styles from "./CustomSelect.module.scss";

interface CustomSelectProps
{
    label: string;
    icon?: string;
    customClassName?: string;
    useHeightTransition?: boolean;
    disabled?: boolean;
}

const CustomSelect = (props: PropsWithChildren<CustomSelectProps>): ReactElement =>
{
    const customSelectRef = useRef<HTMLDivElement>(null as any);
    const [dropdownVisible, setDropdownVisibility] = useState<boolean>(false);

    const handleClickOutside = (e: MouseEvent): void =>
    {
        const target = e.target as HTMLElement;

        if (customSelectRef.current && !customSelectRef.current.contains(target))
            setDropdownVisibility(false);
    };

    useEventListener("click", handleClickOutside);

    return (
        <div
            ref={customSelectRef}
            {...className(
                styles.customSelect,
                props.customClassName, {
                [styles.open]: dropdownVisible
            })}
        >
            <button
                className={styles.toggler}
                onClick={() => setDropdownVisibility(!dropdownVisible)}
                disabled={props.disabled}
            >
                {props.icon && <i className="material-icons">{props.icon}</i>}

                <span>
                    {props.label}
                    <i className="material-icons">expand_more</i>
                </span>
            </button>

            <div {...className(styles.dropdown, props.useHeightTransition ? styles.usesHeight : styles.usesTransform)} onClick={()=>setDropdownVisibility(!dropdownVisible)} >
                {props.children}
            </div>
        </div>
    );
};

export default CustomSelect;
